import React from "react";
import {setPreviewActive} from "../../../../slices/globalParamsSlice";
import {useDispatch} from "react-redux";
import {Container} from "./ClosePreviewButton.style";
import {PreviewIcon} from "../../../icons/PreviewIcon";
import {BorderedButton} from "../../common/BorderedButton";

export const ClosePreviewButton = () => {
    const dispatch = useDispatch();

    const handlePreviewClose = (e) => {
        e.preventDefault();
        dispatch(setPreviewActive(false));
    }

    return (
        <Container>
            <BorderedButton icon={<PreviewIcon active={true}/>}
                            onClick={handlePreviewClose}
                            isPlus={true}
                            isMobile={true}
                            style={{boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)'}}/>
        </Container>
    );
}